import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairProductToServer } from "./mappers/mapRepairProductToServer";
export const removeRepairProduct = async (sessionKey, product) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/product`,
            method: "DELETE",
            data: mapRepairProductToServer(product),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
